/**
 * Must match tss-svc-users PasswordService.validate:
 * 8–128 chars, one uppercase, one lowercase, one number.
 */
export const REGISTER_PASSWORD_MIN = 8;
export const REGISTER_PASSWORD_MAX = 128;

export const REGISTER_PASSWORD_HINT =
  'At least 8 characters, with uppercase, lowercase, and a number';

export function registerPasswordIssues(password: string): string[] {
  const issues: string[] = [];
  if (password.length < REGISTER_PASSWORD_MIN) {
    issues.push(`At least ${REGISTER_PASSWORD_MIN} characters`);
  }
  if (password.length > REGISTER_PASSWORD_MAX) {
    issues.push(`Maximum ${REGISTER_PASSWORD_MAX} characters`);
  }
  if (!/[A-Z]/.test(password)) {
    issues.push('At least one uppercase letter');
  }
  if (!/[a-z]/.test(password)) {
    issues.push('At least one lowercase letter');
  }
  if (!/[0-9]/.test(password)) {
    issues.push('At least one number');
  }
  return issues;
}

export function isRegisterPasswordValid(password: string): boolean {
  return registerPasswordIssues(password).length === 0;
}
